import React from "react";

export default function AdminAccessDenied() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center p-6">
      <div className="card w-full max-w-md p-6 text-center">
        <p className="text-lg font-semibold text-slate-900">Access denied</p>
        <p className="mt-2 text-sm text-slate-600">
          You do not have permission to view this area.
        </p>
      </div>
    </div>
  );
}
